import React from 'react';
import { CalendarDays, Leaf, Users, User } from 'lucide-react';
export type TabType = 'summit' | 'albero' | 'match' | 'profilo';
interface TabBarProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}
const TABS: {
  key: TabType;
  label: string;
  Icon: typeof CalendarDays;
}[] = [{
  key: 'summit',
  label: 'Programma',
  Icon: CalendarDays
}, {
  key: 'albero',
  label: 'Impatto',
  Icon: Leaf
}, {
  key: 'match',
  label: 'Connessioni',
  Icon: Users
}, {
  key: 'profilo',
  label: 'Profilo',
  Icon: User
}];
export function TabBar({
  activeTab,
  onTabChange
}: TabBarProps) {
  return <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] h-[72px] bg-[#0D0D0D]/80 backdrop-blur-xl border-t border-[#2A2A2A]/50 pb-2 z-50" data-id="element-165">
      <div className="flex items-center h-full" data-id="element-166">
        {TABS.map(({
        key,
        label,
        Icon
      }) => {
        const isActive = activeTab === key;
        return <button key={key} onClick={() => onTabChange(key)} className="flex-1 flex flex-col items-center justify-center gap-1 relative h-full" data-id="element-167">
              <Icon className={`w-5 h-5 transition-colors duration-150 ${isActive ? 'text-[#C5D82D]' : 'text-[#999999]'}`} strokeWidth={isActive ? 2 : 1.5} data-id="element-168" />
              <span className={`text-[10px] font-medium tracking-wide transition-colors duration-150 ${isActive ? 'text-[#C5D82D]' : 'text-[#999999]'}`} data-id="element-169">
                {label}
              </span>
            </button>;
      })}
      </div>
    </div>;
}